<template>
  <v-app>
    <Menu
      v-if="
        this.$router.currentRoute.name != 'Login' &&
        !!this.$router.currentRoute.name
      "
    ></Menu>
    <v-main>
      <!-- <v-container fluid id="container"> -->
      <router-view />
      <!-- </v-container> -->
    </v-main>
  </v-app>
</template>

<script>
import Menu from "@/components/menu/Menu";

export default {
  name: "App",
  components: {
    Menu,
  },
  data: () => {
    return {};
  },
  methods: {},
};
</script>
<style lang="scss">
html, body {
  overflow-y: auto !important;
  min-height: 100%;
  background-color: inherit;
}
</style>
